import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-32 bg-[#f5f5f5]">
      <div className="max-w-[1400px] mx-auto px-5">
        <div className="flex flex-col md:grid md:grid-cols-2 md:gap-20 md:items-center">
          {/* 제목 - 모바일에서 먼저 표시 */}
          <div className="block md:hidden mb-5">
            <h2 className="text-xl font-bold text-[#222222] leading-tight text-center">
              뿌리는 즉시 에너지가 되는<br />
              '100% 흡수'의 과학
            </h2>
          </div>

          {/* 이미지 */}
          <div className="relative aspect-[4/3] rounded-2xl overflow-hidden mb-6 md:mb-0">
            <img
              src="https://i.imgur.com/nRlxZ7P.jpeg"
              alt="100% 흡수 과학 기술"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>

          {/* 텍스트 */}
          <div className="text-center md:text-left">
            <h2 className="hidden md:block text-4xl font-bold text-[#222222] mb-6 leading-tight md:text-left">
              뿌리는 즉시 에너지가 되는<br />
              '100% 흡수'의 과학
            </h2>
            <p className="text-sm md:text-lg text-gray-600 leading-relaxed mb-6 md:mb-10">
              전통 발효의 지혜와 현대 과학의 만남. KW테크의 독보적인 미생물 발효 공법은 작물이 영양소를 낭비 없이 흡수하게 합니다. 겉도는 비료가 아닌, 세포 끝까지 전달되는 진정한 영양 솔루션을 경험하세요.
            </p>
            <div className="text-center md:text-left">
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-8 py-3 bg-[#222222] text-white text-sm md:text-base font-medium rounded-full hover:bg-[#333333] transition-colors cursor-pointer whitespace-nowrap"
                aria-label="자세히 보기"
              >
                자세히 보기
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}